/** RU / EN UI strings for Tap Mars */
export const TRANSLATIONS = {
  ru: {
    langName: 'RU',
    bootLoading: 'Готовим колонию на Марсе…',
    bootNeedTelegram: 'Открой Tap Mars через бота @Tap_Mars_bot в Telegram (кнопка «Начать игру»).',
    bootError: 'Ошибка загрузки',
    navHome: 'Главная',
    navBuild: 'Билд',
    navPass: 'Пропуск',
    navSeason: 'Сезон',
    navMore: 'Ещё',
    perHour: '/час',
    perTap: '/тап',
    rubies: 'рубины',
    coins: 'монеты',
    season: 'Сезон',
    friends: 'Друзья',
    howEarnRubies: 'Как заработать рубины',
    rubiesHelpTitle: 'Рубины колонии',
    rubiesHelpBody:
      'Рубины — редкая валюта статуса.\n\n• Топ сезона — главная награда рубинами\n• Боевой пропуск — уровни с рубинами\n• Premium-дорожка пропуска даёт больше\n\nТрать рубины в магазине скинов в разделе «Ещё».',
    close: 'Закрыть',
    gotIt: 'Понятно',
    notEnoughTitle: 'Не хватает средств',
    notEnoughAmber: 'Недостаточно рубинов для покупки',
    notEnoughCoins: 'Недостаточно монет для улучшения',
    balanceNow: 'Сейчас',
    balanceNeed: 'Нужно',
    hubTitle: 'Колония',
    hubSubtitle: 'Скины · кланы · престиж · друзья',
    shop: 'Магазин',
    clans: 'Кланы',
    prestige: 'Престиж',
    exclusives: 'Эксклюзивы за рубины',
    equipped: 'Надето',
    unequip: 'Снять',
    shopSheetHint: 'Выбери предмет — надень или сними в любой момент',
    equip: 'Надеть',
    buy: 'Купить',
    owned: 'Куплено',
    leaveClan: 'Выйти',
    leaveClanConfirm: 'Точно выйти из клана? Прогресс вклада останется в клане.',
    createClan: 'Создать клан',
    join: 'Вступить',
    closed: 'Закрыт',
    clanName: 'Название',
    clanTag: 'ТЕГ',
    topClans: 'Топ кланов',
    power: 'Сила',
    active: 'активны',
    incomeBonus: 'Бонус дохода',
    needOnline: 'нужно ≥70% онлайна',
    prestigeTitle: 'Престиж',
    multiplier: 'Множитель',
    streak: 'Стрик',
    best: 'лучш.',
    seasonBonus: 'бонус сезона',
    shields: 'щиты',
    needCoinsForPrestige: 'Нужно {n} монет, чтобы сбросить апгрейды и поднять множитель',
    doPrestige: 'Сделать престиж',
    prestigeDone: 'Престиж выполнен!',
    boughtRubies: 'Скин куплен за рубины',
    inviteFriends: 'Пригласить друзей',
    inviteCount: 'друзей в колонии',
    referralsBar: 'Друзья и рефералы',
    preview: 'Эффект',
    rarity: 'редкость',
    passTitle: 'Орбитальный пропуск',
    passSubtitle: 'Тапай, бери задания — открывай уровни и награды',
    passLevel: 'Ур.',
    passFree: 'Бесплатно',
    passVip: 'Premium',
    passXp: 'XP',
    passClaim: 'Забрать',
    passClaimed: 'Получено',
    passClaimAll: 'Забрать всё',
    passDaily: 'Дневной орбитальный бонус',
    passDailyClaim: 'Забрать бонус',
    passDailyDone: 'Бонус уже получен сегодня',
    passHowTitle: 'Как качать пропуск',
    passHowTap: 'Тапай на главной — пакеты тапов дают XP',
    passHowTasks: 'Забирай задания — +25–40 XP',
    passHowDaily: 'Дневной бонус — +50 XP и монеты',
    passHowPremium: 'Premium открывает вторую дорожку наград',
    passEnds: 'До конца',
    tasksSection: 'Задания',
    reward: 'Награда',
    claim: 'Забрать',
    done: 'Готово',
    open: 'Открыть',
    daily: 'ежедн.',
    loading: 'Загрузка…',
    premiumBought: 'Premium активирован',
    starsOnly: 'Оплата Stars только в Telegram',
    buildTitle: 'Билд колонии',
    buildSubtitle: 'Улучшай тап, доход и энергию',
    maxed: 'Макс',
    seasonTitle: 'Сезонный рейтинг',
    seasonSubtitle: 'Фарми очки — забирай рубины в топе',
    top100: 'Топ-100',
    topEmpty: 'В сезоне пока никого — стань первым',
    nearby: 'Рядом',
    you: 'ВЫ',
    league: 'Лига',
    points: 'очки',
    friendsTitle: 'Приглашай друзей',
    friendsSubtitle: 'Бонус с их фарма и рост колонии',
    copyLink: 'Копировать ссылку',
    share: 'Поделиться',
    linkCopied: 'Ссылка скопирована',
    language: 'Язык',
    support: 'Написать в поддержку',
    slot_button: 'Обводка',
    slot_planet: 'Планета',
    slot_frame: 'Рамка',
    slot_title: 'Титул',
    slot_tap_fx: 'Эффект тапа',
    slotHint_frame: 'Рамка вокруг аватара — видно в шапке и в топе сезона.',
    slotHint_button: 'Обод вокруг сферы тапа: железо, магма, стекло, реактор. Планета под ним — отдельно.',
    slotHint_planet: 'Сама сфера, по которой тапаешь. Меняет мир целиком + ауру вокруг.',
    slotHint_title: 'Плашка-титул рядом с именем в шапке. Её видят все.',
    slotHint_tap_fx: 'Частицы при каждом тапе — у каждого эффекта своя форма и полёт.',
    branchTap: 'Тап',
    branchFarm: 'Фарм',
    branchEnergy: 'Энергия',
    energyBuildHint:
      'Энергия тратится на тапы. «Запас» — сколько можно вытапать за раз. «Реген» — как быстро шкала восстанавливается. Улучшения за Stars дают самый сильный прирост.',
    buildGoalSave: 'Копи на апгрейд',
    buildGoalReady: 'Можно купить',
    shopAll: 'Все',
    clanPublic: 'Открытый',
    clanPrivate: 'Приватный',
    makePrivate: 'Сделать приватным',
    makePublic: 'Сделать открытым',
    inviteLink: 'Ссылка-приглашение',
    joinByCode: 'Вступить по коду',
    starsLabel: 'Stars',
    levelShort: 'Ур.',
    maxShort: 'МАКС',
    topLeague: 'Верхняя лига!',
    seasonLeaguesTitle: 'Лиги сезона',
    seasonLeaguesBody:
      'Лиги считаются по процентилю места среди всех игроков. Поднимайся тапами и фармом очков сезона.',
    endSeasonRubies: 'Рубины в конце сезона',
    emptyShop: 'В этой категории пока пусто',
    emptyBuild: 'Нет улучшений в этой ветке',
    synTap: 'Тап',
    synFarm: 'Фарм',
    synEnergy: 'Энергия',
    dailyTitle: 'Календарь наград',
    dailySubtitle: 'Заходи каждый день — стрик растёт до 14 дней',
    claimDailyBtn: 'Забрать день',
    dayN: 'День {n}',
    offlineTitle: 'Пока тебя не было',
    offlineBody: 'Колония добыла {n} монет',
    claimOfflineBtn: 'Забрать доход',
    obTapTitle: 'Тапай по Марсу',
    obTapBody: 'Каждый тап даёт монеты и XP пропуска. Следи за энергией.',
    obBuildTitle: 'Прокачай билд',
    obBuildBody: 'Улучшай тап, фарм и энергию — колония растёт быстрее.',
    obPassTitle: 'Орбитальный пропуск',
    obPassBody: 'Набирай XP и забирай рубины с уровней пропуска.',
    obNext: 'Далее',
    obSkip: 'Пропустить',
    tryPreview: 'Превью',
    previewSkin: 'Превью скина',
    seasonFrames: 'Сезонные рамки',
    seasonOnly: 'только сезон',
    // --- Ателье (магазин косметики) ---
    atelierTitle: 'Ателье колонии',
    atelierKicker: 'Коллекция за рубины',
    atelierHint: 'Скины навсегда. Планета — на главной; рамка и титул — в шапке и топе.',
    atelierSpotlight: 'Легенда Ателье',
    ownersNone: 'Ни у кого в колонии',
    ownersFew: 'Всего у {n} в колонии',
    ownersPct: 'Есть у {p}% колонии',
    collectionProgress: 'Собрано {a}/{b}',
    ownedTag: 'В коллекции',
    equippedTag: 'Надето',
    needMore: 'Не хватает {n}',
    rarity_common: 'Обычный',
    rarity_rare: 'Редкий',
    rarity_epic: 'Эпический',
    rarity_legendary: 'Легендарный',
    rarity_mythic: 'Мифический',
    buyConfirmTitle: 'Купить «{n}»?',
    buyConfirmBody: 'Списывается {p} рубинов. Предмет останется у вас навсегда и наденется сразу.',
    buyAction: 'Купить',
    ownedCount: 'У вас {n} из {b} предметов Ателье',
    slotDone: 'Категория собрана полностью',
    lockedByRubies: 'Копите рубины в сезонном топе и пропуске',
    clanWeekGoal: 'Цель недели',
    transferClan: 'Передать',
    disbandClan: 'Распустить',
    transferConfirm: 'Передать клан игроку {n}?',
    disbandConfirm: 'Распустить клан навсегда? Это нельзя отменить.',
    clanTransferred: 'Клан передан',
    clanDisbanded: 'Клан распущен',
    clanOwner: 'владелец',
    giftHint: '1 подарок в день рефералу: энергия или монеты',
    giftEnergy: '+энергия',
    giftCoins: '+монеты',
    giftSent: 'Подарок отправлен!',
    giftUsed: 'Подарок сегодня уже отправлен',
    later: 'Позже',
    boostCta: 'Прокачать',
    ownerLeaveHint: 'Чтобы выйти — передайте клан или распустите его',
    homeAdd: 'На экран',
    homeUnsupported: 'Ярлык недоступен на этом устройстве',
    homeAddHint: 'Добавь ярлык и нажми ещё раз',
    homeConfirmBody: 'Добавил Tap Mars на домашний экран? Нажми «Да» — награда будет доступна.',
    homeConfirmYes: 'Да, добавил',
    homeManualBody: 'В меню Telegram (⋯) нажми «Добавить на главный экран», затем «Да».',
    homeNeedOfficial:
      'В этом клиенте нет API ярлыка. Открой официальный Telegram → меню ⋯ → «Добавить на главный экран».',
    boostThenRecheck: 'Забусти канал — проверка пройдёт сама, когда вернёшься в игру.',
    starsSentChat: 'Счёт отправлен в чат с ботом — открой @Tap_Mars_bot и оплати там.',
    starsTapAgain: 'Нажми кнопку ещё раз, чтобы открыть оплату.',
    clanDesc: 'Описание клана (видят только свои)',
    clanDescEmpty: 'Описания пока нет',
    clanMembers: 'Участники',
    clansGateTitle: 'Колония ждёт команду',
    clansGateBody: 'Создай клан за 100 монет или вступи по коду друга',
    createClanCost: 'Создание стоит {n} монет',
    clanNameTagRequired: 'Укажи название и тег',
    joinByCodeBody: 'Вставь код приглашения клана',
    save: 'Сохранить',
    prestigeConfirm: 'Сбросит монеты и апгрейды. Множитель тапа вырастет навсегда. Продолжить?',
    seasonWeekly: 'Недельный сезон · Пн 00:00 → Вс 23:59 МСК',
    prestigeHelpTitle: 'Что такое престиж?',
    prestigeHelpBody:
      'Престиж — это «новый круг» колонии: вы сбрасываете прогресс апгрейдов, чтобы навсегда ускорить заработок с тапа.\n\n' +
      'Что происходит при престиже:\n' +
      '• Монеты обнуляются.\n' +
      '• Уровни улучшений (тап, фарм, энергия) сбрасываются к старту.\n' +
      '• Постоянный множитель монет с тапа растёт — он остаётся навсегда и суммируется с каждым следующим престижем.\n\n' +
      'Что НЕ сбрасывается:\n' +
      '• Рубины (премиум-валюта)\n' +
      '• Купленные и экипированные скины\n' +
      '• Боевой пропуск и его прогресс\n' +
      '• Очки текущего сезона и лига\n' +
      '• Клан, вклад в клан, друзья и рефералы\n\n' +
      'Условия:\n' +
      '• Нужно накопить достаточно монет (порог растёт с уровнем престижа).\n' +
      '• Пока порог не достигнут — кнопка недоступна.\n\n' +
      'Стрик и щиты:\n' +
      '• Ежедневный вход повышает стрик и даёт небольшой бонус к сезону.\n' +
      '• Щиты защищают стрик, если вы пропустили день.\n\n' +
      'Когда престижиться:\n' +
      'Когда апгрейды стали дорогими, а рост монет замедлился — престиж даст множитель, и новый круг пойдёт заметно быстрее. Не престижьтесь слишком рано: сначала выжмите текущий цикл.',
    kickMember: 'Исключить',
    kickConfirm: 'Исключить {n} из клана?',
    inactiveToday: 'был сегодня',
    inactiveDays: 'неактив {n} дн.',
    inactiveNever: 'ещё не заходил',
    clanInviteShort: 'Пригласить',
    transferShort: 'Передать',
    kickShort: 'Кик',
    disbandShort: 'Распустить',
    privacyShortPublic: 'Открытый',
    privacyShortPrivate: 'Закрытый',
    clanAdmin: 'Управление',
    boostChannel: 'Буст',
    visitFreelance: 'Открыть биржу',
    visitFreelanceHint: 'Открой Tap Mars Freelance и запусти приложение — вернись сюда, задание проверится само',
    passSub: 'Подписка / мес',
    shareStory: 'Сторис сезона',
    storyUnsupported: 'Сторис недоступны в этом клиенте',
    shakeHint: 'Тряхни телефон — мелкая награда раз в день',
    seasonPlayers: 'игроков',
    seasonEndsIn: 'До конца',
    yourPlace: 'твоё место',
    top1Ruby: 'топ-1 рубины',
    toNextLeague: 'До следующей лиги',
    rank: 'Ранг',
    passRubiesHint: 'рубины колонии (не Stars)',
    profileStats: 'Статистика колониста',
    statJoined: 'Первый вход',
    statTaps: 'Всего тапов',
    statLifetimeCoins: 'Монет заработано',
    statBalance: 'Баланс монет',
    statRubies: 'Рубины',
    statRubiesLifetime: 'Рубинов за всё время',
    statPrestige: 'Престиж',
    statReferrals: 'Рефералов',
    statClan: 'Клан',
    statNoClan: 'нет клана',
    statPerTap: 'За тап',
    statPerHour: 'В час',
    statEnergyCap: 'Макс. энергия',
    yourProjectedReward: 'Твоя награда сейчас',
    placeShort: 'Место',
    outsideRewards: 'вне зоны наград',
    seasonTitlePrize: 'титул',
    lastSeason: 'Прошлый сезон',
    leagueLadder: 'Лестница лиг',
    seasonUrgent: 'Меньше суток до финиша — закрепи место!',
    friendsHelpTitle: 'Как работают друзья',
    friendsHelpBody:
      'Друзья — это колонисты, которых ты пригласил по своей ссылке.\n\n' +
      '• За каждого нового друга ты получаешь монеты сразу после его первого входа.\n' +
      '• Пока друг активен, ты получаешь процент с его фарма (пассивный доход).\n' +
      '• Чем больше друзей — тем быстрее растёт колония и сезонная сила.\n' +
      '• Раз в день можно отправить одному другу подарок: энергию или монеты.\n' +
      '• Подарок уходит только если у тебя ещё не потрачен дневной слот.\n\n' +
      'Как пригласить:\n' +
      '1) Нажми «Поделиться» — откроется выбор чата в Telegram.\n' +
      '2) Или скопируй ссылку и отправь вручную.\n' +
      '3) Друг должен открыть ссылку и запустить игру через @Tap_Mars_bot.\n\n' +
      'Советы:\n' +
      '• Зови активных игроков — пассивный % идёт только с живой активности.\n' +
      '• Следи за списком друзей ниже: дата входа показывает, кто уже в колонии.\n' +
      '• Подарки — хороший способ вернуть друга в игру на день.',

    // --- дуэли ---
    duelsTitle: 'Дуэли',
    duelsSubtitle: 'Ставка против ставки. Побеждает тот, кто больше выжал.',
    duelsSubtitleActive: 'Идёт бой — каждый твой тап уходит в счёт.',
    duelsEntryHint: 'Вызвать соперника и забрать его ставку',
    duelChallenge: 'Вызвать на дуэль',
    duelTaps: 'тапов',
    duelStake: 'Ставка',
    duelRating: 'Рейтинг',
    duelCasual: 'без рейтинга',
    duelFind: 'Найти соперника',
    duelSendChallenge: 'Отправить вызов',
    duelChallengeTo: 'Вызов для {name}',
    duelSearching: 'Ищем соперника…',
    duelSearchingHint: 'Как только найдётся равный — бой начнётся сам',
    duelSearchingOpponent: 'Соперник ищется',
    duelCancel: 'Отменить',
    duelAccept: 'Принять',
    duelDecline: 'Отклонить',
    duelTake: 'Принять бой',
    duelRematch: 'Реванш',
    duelIncoming: 'Вас вызвали',
    duelOutgoing: 'Ваши вызовы',
    duelOpenQueue: 'Открытые вызовы',
    duelOpenQueueHint: 'Игроки вашего уровня уже ждут соперника',
    duelHistory: 'История боёв',
    duelEmpty: 'Дуэлей ещё не было. Выберите формат, поставьте монеты и найдите соперника.',
    duelAhead: 'Вы ведёте — не сбавляйте темп',
    duelBehind: 'Вы отстаёте — ещё можно догнать',
    duelEven: 'Идёте вровень',
    duelAheadShort: 'ведёте',
    duelBehindShort: 'отстаёте',
    duelEvenShort: 'вровень',
    duelGoTap: 'В бой — тапать',
    duelArenaHint: 'Счёт растёт от тапов на главном экране. Полоска боя видна отовсюду.',
    duelWin: 'Победа',
    duelLose: 'Поражение',
    duelDraw: 'Ничья',
    duelRefunded: 'ставки возвращены',
    duelPlacement: 'Ещё {n} калибровочных боёв — потом рейтинг встанет на место',
    duelTopTier: 'Высшая лига. Дальше только держать.',
    duelInviteTitle: '{name} вызывает на дуэль',
    duelOpen: 'Открыть',
    duelFailed: 'Не удалось начать дуэль',
    duelPot: 'банк',
    duelFinalPush: 'Финальный рывок',
    duelToNextTier: 'До лиги «{tier}» — {n} рейтинга',
    duelTabPlay: 'Бой',
    duelTabHistory: 'История',
    duelTabLadder: 'Лучшие',
    duelLadderEmpty: 'Рейтинг пока пуст. Проведите первый бой — и попадёте в список.',
    duelProjection: 'По темпу',
    duelProjectionWin: 'этого хватает',
    duelProjectionLose: 'не хватает',
    duelProjectionClose: 'вплотную',
    duelAtStake: 'На кону ',
    duelCredited: 'Зачислено на баланс',
  },
  en: {
    langName: 'EN',
    bootLoading: 'Preparing the Mars colony…',
    bootNeedTelegram: 'Open Tap Mars via @Tap_Mars_bot in Telegram (“Start game”).',
    bootError: 'Load error',
    navHome: 'Home',
    navBuild: 'Build',
    navPass: 'Pass',
    navSeason: 'Season',
    navMore: 'More',
    perHour: '/hr',
    perTap: '/tap',
    rubies: 'rubies',
    coins: 'coins',
    season: 'Season',
    friends: 'Friends',
    howEarnRubies: 'How to earn rubies',
    rubiesHelpTitle: 'Colony rubies',
    rubiesHelpBody:
      'Rubies are the premium status currency.\n\n• Season top — main ruby rewards\n• Battle Pass levels with rubies\n• Premium track pays more\n\nSpend rubies on skins in More → Shop.',
    close: 'Close',
    gotIt: 'Got it',
    notEnoughTitle: 'Not enough funds',
    notEnoughAmber: 'Not enough rubies for this purchase',
    notEnoughCoins: 'Not enough coins for this upgrade',
    balanceNow: 'Have',
    balanceNeed: 'Need',
    hubTitle: 'Colony',
    hubSubtitle: 'Skins · clans · prestige · friends',
    shop: 'Shop',
    clans: 'Clans',
    prestige: 'Prestige',
    exclusives: 'Ruby exclusives',
    equipped: 'Equipped',
    unequip: 'Unequip',
    shopSheetHint: 'Pick an item — equip or unequip anytime',
    equip: 'Equip',
    buy: 'Buy',
    owned: 'Owned',
    leaveClan: 'Leave',
    leaveClanConfirm: 'Leave this clan? Your contribution stays with the clan.',
    createClan: 'Create clan',
    join: 'Join',
    closed: 'Closed',
    clanName: 'Name',
    clanTag: 'TAG',
    topClans: 'Top clans',
    power: 'Power',
    active: 'active',
    incomeBonus: 'Income bonus',
    needOnline: 'need ≥70% online',
    prestigeTitle: 'Prestige',
    multiplier: 'Multiplier',
    streak: 'Streak',
    best: 'best',
    seasonBonus: 'season bonus',
    shields: 'shields',
    needCoinsForPrestige: 'Need {n} coins to reset upgrades and raise multiplier',
    doPrestige: 'Prestige now',
    prestigeDone: 'Prestige complete!',
    boughtRubies: 'Skin purchased with rubies',
    inviteFriends: 'Invite friends',
    inviteCount: 'friends in colony',
    referralsBar: 'Friends & referrals',
    preview: 'Effect',
    rarity: 'rarity',
    passTitle: 'Orbital Pass',
    passSubtitle: 'Tap, clear quests — unlock levels & rewards',
    passLevel: 'Lv.',
    passFree: 'Free',
    passVip: 'Premium',
    passXp: 'XP',
    passClaim: 'Claim',
    passClaimed: 'Claimed',
    passClaimAll: 'Claim all',
    passDaily: 'Daily orbital bonus',
    passDailyClaim: 'Claim bonus',
    passDailyDone: 'Already claimed today',
    passHowTitle: 'How to level the Pass',
    passHowTap: 'Tap on Home — tap batches grant XP',
    passHowTasks: 'Claim quests — +25–40 XP',
    passHowDaily: 'Daily bonus — +50 XP and coins',
    passHowPremium: 'Premium unlocks the second reward track',
    passEnds: 'Ends in',
    tasksSection: 'Quests',
    reward: 'Reward',
    claim: 'Claim',
    done: 'Done',
    open: 'Open',
    daily: 'daily',
    loading: 'Loading…',
    premiumBought: 'Premium unlocked',
    starsOnly: 'Stars checkout only inside Telegram',
    buildTitle: 'Colony build',
    buildSubtitle: 'Upgrade tap, income and energy',
    maxed: 'Max',
    seasonTitle: 'Season ranking',
    seasonSubtitle: 'Farm points — earn rubies from the top',
    top100: 'Top 100',
    topEmpty: 'Nobody in the season yet — be the first',
    nearby: 'Nearby',
    you: 'YOU',
    league: 'League',
    points: 'pts',
    friendsTitle: 'Invite friends',
    friendsSubtitle: 'Earn a cut of their farming',
    copyLink: 'Copy link',
    share: 'Share',
    linkCopied: 'Link copied',
    language: 'Language',
    support: 'Contact support',
    slot_button: 'Bezel',
    slot_planet: 'Planet',
    slot_frame: 'Frame',
    slot_title: 'Title',
    slot_tap_fx: 'Tap FX',
    slotHint_frame: 'Avatar frame — visible in the header and season leaderboard.',
    slotHint_button: 'A rim around the tap sphere: iron, magma, glass, reactor. The planet underneath is separate.',
    slotHint_planet: 'The sphere you tap. Replaces the whole world plus the aura around it.',
    slotHint_title: 'A title plaque next to your name in the header. Everyone can see it.',
    slotHint_tap_fx: 'Particles on every tap — each effect has its own shape and flight.',
    branchTap: 'Tap',
    branchFarm: 'Farm',
    branchEnergy: 'Energy',
    energyBuildHint:
      'Energy is spent on taps. Cap = how many taps before empty. Regen = how fast it refills. Star upgrades give the strongest boost.',
    buildGoalSave: 'Save for upgrade',
    buildGoalReady: 'Ready to buy',
    shopAll: 'All',
    clanPublic: 'Public',
    clanPrivate: 'Private',
    makePrivate: 'Make private',
    makePublic: 'Make public',
    inviteLink: 'Invite link',
    joinByCode: 'Join by code',
    starsLabel: 'Stars',
    levelShort: 'Lv.',
    maxShort: 'MAX',
    topLeague: 'Top league!',
    seasonLeaguesTitle: 'Season leagues',
    seasonLeaguesBody:
      'Leagues are based on your rank percentile among all players. Climb by tapping and farming season points.',
    endSeasonRubies: 'End-of-season rubies',
    emptyShop: 'Nothing in this category yet',
    emptyBuild: 'No upgrades in this branch',
    synTap: 'Tap',
    synFarm: 'Farm',
    synEnergy: 'Energy',
    dailyTitle: 'Reward calendar',
    dailySubtitle: 'Log in daily — streak grows up to 14 days',
    claimDailyBtn: 'Claim day',
    dayN: 'Day {n}',
    offlineTitle: 'While you were away',
    offlineBody: 'Your colony mined {n} coins',
    claimOfflineBtn: 'Claim income',
    obTapTitle: 'Tap Mars',
    obTapBody: 'Every tap earns coins and Pass XP. Watch your energy.',
    obBuildTitle: 'Upgrade the build',
    obBuildBody: 'Boost tap, farm and energy — the colony grows faster.',
    obPassTitle: 'Orbital Pass',
    obPassBody: 'Earn XP and claim rubies from Pass levels.',
    obNext: 'Next',
    obSkip: 'Skip',
    tryPreview: 'Preview',
    previewSkin: 'Skin preview',
    seasonFrames: 'Season frames',
    seasonOnly: 'season only',
    // --- Atelier (cosmetics shop) ---
    atelierTitle: 'Colony Atelier',
    atelierKicker: 'The ruby collection',
    atelierHint: 'Skins are forever. Planet on Home; frame & title in the header and top.',
    atelierSpotlight: 'Atelier legend',
    ownersNone: 'Nobody in the colony owns it',
    ownersFew: 'Only {n} in the colony own it',
    ownersPct: 'Owned by {p}% of the colony',
    collectionProgress: 'Collected {a}/{b}',
    ownedTag: 'In collection',
    equippedTag: 'Equipped',
    needMore: '{n} short',
    rarity_common: 'Common',
    rarity_rare: 'Rare',
    rarity_epic: 'Epic',
    rarity_legendary: 'Legendary',
    rarity_mythic: 'Mythic',
    buyConfirmTitle: 'Buy “{n}”?',
    buyConfirmBody: 'Costs {p} rubies. The item is yours forever and equips right away.',
    buyAction: 'Buy',
    ownedCount: 'You own {n} of {b} Atelier items',
    slotDone: 'Category fully collected',
    lockedByRubies: 'Earn rubies from the season top and the Pass',
    clanWeekGoal: 'Weekly goal',
    transferClan: 'Transfer',
    disbandClan: 'Disband',
    transferConfirm: 'Transfer clan to {n}?',
    disbandConfirm: 'Disband the clan forever? This cannot be undone.',
    clanTransferred: 'Clan transferred',
    clanDisbanded: 'Clan disbanded',
    clanOwner: 'owner',
    giftHint: '1 gift per day to a referral: energy or coins',
    giftEnergy: '+energy',
    giftCoins: '+coins',
    giftSent: 'Gift sent!',
    giftUsed: 'Already gifted today',
    later: 'Later',
    boostCta: 'Upgrade',
    ownerLeaveHint: 'To leave — transfer the clan or disband it',
    homeAdd: 'Home screen',
    homeUnsupported: 'Shortcuts unavailable on this device',
    homeAddHint: 'Add the shortcut, then tap again',
    homeConfirmBody: 'Did you add Tap Mars to the home screen? Tap Yes to unlock the reward.',
    homeConfirmYes: 'Yes, added',
    homeManualBody: 'In Telegram menu (⋯) choose “Add to Home Screen”, then tap Yes.',
    homeNeedOfficial:
      'Home shortcut API is missing in this client. Open official Telegram → menu ⋯ → Add to Home Screen.',
    boostThenRecheck: 'Boost the channel — we will verify automatically when you return.',
    starsSentChat: 'Invoice sent to the bot chat — open @Tap_Mars_bot and pay there.',
    starsTapAgain: 'Tap the button again to open payment.',
    clanDesc: 'Clan description (members only)',
    clanDescEmpty: 'No description yet',
    clanMembers: 'Members',
    clansGateTitle: 'Your colony needs a crew',
    clansGateBody: 'Create a clan for 100 coins or join with a code',
    createClanCost: 'Creating costs {n} coins',
    clanNameTagRequired: 'Name and tag are required',
    joinByCodeBody: 'Paste the clan invite code',
    save: 'Save',
    prestigeConfirm: 'Resets coins and upgrades. Tap multiplier rises forever. Continue?',
    seasonWeekly: 'Weekly season · Mon 00:00 → Sun 23:59 MSK',
    prestigeHelpTitle: 'What is prestige?',
    prestigeHelpBody:
      'Prestige is a “new run” for your colony: you reset upgrade progress to permanently speed up tap earnings.\n\n' +
      'What prestige does:\n' +
      '• Coins reset to zero.\n' +
      '• Upgrade levels (tap, farm, energy) return to the start.\n' +
      '• Your permanent coins-per-tap multiplier increases — it stays forever and stacks with every prestige.\n\n' +
      'What you KEEP:\n' +
      '• Rubies (premium currency)\n' +
      '• Owned / equipped skins\n' +
      '• Battle Pass progress\n' +
      '• Current season points and league\n' +
      '• Clan, clan contribution, friends and referrals\n\n' +
      'Requirements:\n' +
      '• You must reach a coin threshold (it rises with prestige level).\n' +
      '• Until then the prestige button stays locked.\n\n' +
      'Streak & shields:\n' +
      '• Daily logins raise your streak and give a small season bonus.\n' +
      '• Shields protect the streak if you miss a day.\n\n' +
      'When to prestige:\n' +
      'When upgrades feel expensive and growth slows — prestige grants a multiplier so the next run feels much faster. Don’t prestige too early: squeeze value from the current cycle first.',
    kickMember: 'Kick',
    kickConfirm: 'Kick {n} from the clan?',
    inactiveToday: 'active today',
    inactiveDays: 'idle {n}d',
    inactiveNever: 'never active',
    clanInviteShort: 'Invite',
    transferShort: 'Transfer',
    kickShort: 'Kick',
    disbandShort: 'Disband',
    privacyShortPublic: 'Open',
    privacyShortPrivate: 'Closed',
    clanAdmin: 'Manage',
    boostChannel: 'Boost',
    visitFreelance: 'Open board',
    visitFreelanceHint: 'Open Tap Mars Freelance and launch the app — come back and the quest verifies itself',
    passSub: 'Sub / mo',
    shareStory: 'Season story',
    storyUnsupported: 'Stories unavailable in this client',
    shakeHint: 'Shake the phone — tiny once-a-day bonus',
    seasonPlayers: 'players',
    seasonEndsIn: 'Ends in',
    yourPlace: 'your place',
    top1Ruby: 'top-1 rubies',
    toNextLeague: 'To next league',
    rank: 'Rank',
    passRubiesHint: 'colony rubies (not Stars)',
    profileStats: 'Colonist stats',
    statJoined: 'First login',
    statTaps: 'Total taps',
    statLifetimeCoins: 'Coins earned',
    statBalance: 'Coin balance',
    statRubies: 'Rubies',
    statRubiesLifetime: 'Rubies lifetime',
    statPrestige: 'Prestige',
    statReferrals: 'Referrals',
    statClan: 'Clan',
    statNoClan: 'no clan',
    statPerTap: 'Per tap',
    statPerHour: 'Per hour',
    statEnergyCap: 'Max energy',
    yourProjectedReward: 'Your projected reward',
    placeShort: 'Place',
    outsideRewards: 'outside reward zone',
    seasonTitlePrize: 'title',
    lastSeason: 'Last season',
    leagueLadder: 'League ladder',
    seasonUrgent: 'Under 24h left — lock your place!',
    friendsHelpTitle: 'How friends work',
    friendsHelpBody:
      'Friends are colonists you invited with your link.\n\n' +
      '• Each new friend grants you coins after their first login.\n' +
      '• While a friend stays active, you earn a cut of their farming.\n' +
      '• More friends = faster colony growth and seasonal power.\n' +
      '• Once per day you can send one friend a gift: energy or coins.\n' +
      '• The gift works only if your daily gift slot is still free.\n\n' +
      'How to invite:\n' +
      '1) Tap Share — pick a Telegram chat.\n' +
      '2) Or copy the link and send it manually.\n' +
      '3) They must open the link and start via @Tap_Mars_bot.\n\n' +
      'Tips:\n' +
      '• Invite active players — the passive % needs real activity.\n' +
      '• Check the list below: join date shows who already joined.\n' +
      '• Gifts are a great way to pull a friend back for the day.',

    // --- duels ---
    duelsTitle: 'Duels',
    duelsSubtitle: 'Stake against stake. Whoever squeezes harder takes it all.',
    duelsSubtitleActive: 'Fight in progress — every tap counts.',
    duelsEntryHint: 'Challenge a rival and take their stake',
    duelChallenge: 'Challenge to a duel',
    duelTaps: 'taps',
    duelStake: 'Stake',
    duelRating: 'Rating',
    duelCasual: 'unranked',
    duelFind: 'Find opponent',
    duelSendChallenge: 'Send challenge',
    duelChallengeTo: 'Challenge for {name}',
    duelSearching: 'Looking for an opponent…',
    duelSearchingHint: 'The fight starts the moment an equal shows up',
    duelSearchingOpponent: 'Waiting for an opponent',
    duelCancel: 'Cancel',
    duelAccept: 'Accept',
    duelDecline: 'Decline',
    duelTake: 'Take the fight',
    duelRematch: 'Rematch',
    duelIncoming: 'You were challenged',
    duelOutgoing: 'Your challenges',
    duelOpenQueue: 'Open challenges',
    duelOpenQueueHint: 'Players at your level are already waiting',
    duelHistory: 'Fight history',
    duelEmpty: 'No duels yet. Pick a format, set a stake and find an opponent.',
    duelAhead: 'You are ahead — keep the pace',
    duelBehind: 'You are behind — still catchable',
    duelEven: 'Neck and neck',
    duelAheadShort: 'ahead',
    duelBehindShort: 'behind',
    duelEvenShort: 'even',
    duelGoTap: 'Fight — start tapping',
    duelArenaHint: 'Your score grows from taps on the main screen. The fight bar follows you everywhere.',
    duelWin: 'Victory',
    duelLose: 'Defeat',
    duelDraw: 'Draw',
    duelRefunded: 'stakes refunded',
    duelPlacement: '{n} placement fights left — then your rating settles',
    duelTopTier: 'Top league. Only holding it left.',
    duelInviteTitle: '{name} challenges you',
    duelOpen: 'Open',
    duelFailed: 'Could not start the duel',
    duelPot: 'pot',
    duelFinalPush: 'Final push',
    duelToNextTier: '{n} rating to {tier}',
    duelTabPlay: 'Fight',
    duelTabHistory: 'History',
    duelTabLadder: 'Best',
    duelLadderEmpty: 'The ladder is empty. Fight once and you are on it.',
    duelProjection: 'At this pace',
    duelProjectionWin: 'enough to win',
    duelProjectionLose: 'not enough',
    duelProjectionClose: 'too close',
    duelAtStake: 'At stake ',
    duelCredited: 'Credited to balance',
  },
};

export function normalizeLang(code) {
  const c = String(code || '').toLowerCase();
  if (c.startsWith('ru')) return 'ru';
  if (c === 'en' || c.startsWith('en')) return 'en';
  return c === 'ru' || c === 'en' ? c : 'ru';
}
